class CsrfToken
{
    private static _instance: CsrfToken

    public name: string = 'csrf-param';
    public content: string = 'csrf-token';

    public static get Instance() {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        this.name = document.querySelector('meta[name="csrf-param"]')
            ?.getAttribute('content') || 'csrf-param';
        this.content = document.querySelector('meta[name="csrf-token"]')
            ?.getAttribute('content') || 'csrf-token';
    }
}

export const csrfTokenInstance = CsrfToken.Instance;